import logPageView from './page_view';
import elementClickedListener from './elementClickedListener';

export default () => {
  logPageView();
  // Need a way for react components to render
  // in oder to process segment events.
  setTimeout(() => {
    elementClickedListener();
  }, 180);
};
